import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

// Config for Payout report table
const tableConfig = [
  {
    id: "payoutId",
    header: "Payout",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "payDate",
    header: "Pay Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "mileageRate",
    header: "Mileage Rate",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "emptyRate",
    header: "Empty Rate",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "hourlyRate",
    header: "Hourly Rate",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "totalMileage",
    header: "Total Miles",
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return `${value.toLocaleString()} mi`;
    },
  },
  {
    id: "mileageTotal",
    header: "Mileage Total",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "supplementalTotal",
    header: "Supplemental Total",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "total",
    header: "Gross",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
